export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FETCH_PRODUCT_PAGE_DATA = 'FETCH_PRODUCT_PAGE_DATA'
export const FETCH_PRODUCT_PAGE_DATA_REQUEST = 'FETCH_PRODUCT_PAGE_DATA_REQUEST'
export const FETCH_PRODUCT_ON_CATEGORY = 'FETCH_PRODUCT_ON_CATEGORY'
export const FETCH_PRODUCT_ON_CATEGORY_REQUEST = 'FETCH_PRODUCT_ON_CATEGORY_REQUEST'
export const FETCH_PRODUCT_PAGE_DATA_RESET = 'FETCH_PRODUCT_PAGE_DATA_RESET'
export const FETCH_PRODUCT_OPTIONS = 'FETCH_PRODUCT_OPTIONS'
export const FETCH_PRODUCT_OPTIONS_VALUE = 'FETCH_PRODUCT_OPTIONS_VALUE'



// WEBPACK FOOTER //
// ./src/constants/index.js